/* tslint:disable */ 
import * as React from 'react';
import * as chartjs from 'chart.js';
import { Bar, ChartData } from 'react-chartjs-2';

interface CommonAxe {
    type?: chartjs.ScaleType | string;
    display?: boolean;
    id?: string;
    stacked?: boolean;
    position?: string;
    ticks?: chartjs.LinearTickOptions;
    gridLines?: chartjs.GridLineOptions;
    barThickness?: number;
    scaleLabel?: chartjs.ScaleTitleOptions;
}

interface ChartScales {
    type?: chartjs.ScaleType | string;
    display?: boolean;
    position?: chartjs.PositionType | string;
    gridLines?: chartjs.GridLineOptions;
    scaleLabel?: chartjs.ScaleTitleOptions;
    ticks?: chartjs.LinearTickOptions;
    xAxes?: chartjs.ChartXAxe[];
    yAxes?: CommonAxe[];
    beforeUpdate?(scale?: any): void;
    beforeSetDimension?(scale?: any): void;
    beforeDataLimits?(scale?: any): void;
    beforeBuildTicks?(scale?: any): void;
    beforeTickToLabelConversion?(scale?: any): void;
    beforeCalculateTickRotation?(scale?: any): void;
    beforeFit?(scale?: any): void;
    afterUpdate?(scale?: any): void;
    afterSetDimension?(scale?: any): void;
    afterDataLimits?(scale?: any): void;
    afterBuildTicks?(scale?: any): void;
    afterTickToLabelConversion?(scale?: any): void;
    afterCalculateTickRotation?(scale?: any): void;
    afterFit?(scale?: any): void;
}

interface ChartOptions {
    responsive?: boolean;
    responsiveAnimationDuration?: number;
    maintainAspectRatio?: boolean;
    events?: string[];
    title?: chartjs.ChartTitleOptions;
    legend?: chartjs.ChartLegendOptions;
    tooltips?: chartjs. ChartTooltipOptions;
    hover?: chartjs.ChartHoverOptions;
    animation?: chartjs.ChartAnimationOptions;
    elements?: chartjs.ChartElementsOptions;
    scales?: ChartScales;
    showLines?: boolean;
    spanGaps?: boolean;
    cutoutPercentage?: number;
    circumference?: number;
    rotation?: number;
    onClick?(any?: any): any;
}

// Component
export interface IProps {
    data: ChartData<chartjs.ChartData>;
    type?: chartjs.ChartType;
    height?: number;
    legend?: chartjs.ChartLegendOptions;
    options?: ChartOptions;
    redraw?: boolean;
    width?: number;
    getDatasetAtEvent?(e: any): void;
    getElementAtEvent?(e: any): void;
    getElementsAtEvent?(e: any): void;
    onElementsClick?(e: any): void; // alias for getElementsAtEvent (backward compatibility)
}
function BarChart(props: IProps) {
    return <Bar {...props} />;
}

export default BarChart;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Chart/BarChart.tsx